// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"CodeBlock-primaryButton-3LyFr1","container":"CodeBlock-container-2KMBtC","codeBlockWrapper":"CodeBlock-codeBlockWrapper-6ZpUbZ"};